<template>
  <div class="footer">
    <div class="wp tc">
      {{info.company}}<br>
      地址：{{info.address}}<br>
      电话：{{info.mobile}} 官网地址：{{info.guanwang}}<br>
      {{info.beianhao}}<br>
    </div>
    <div id="guanwang" style="display: none;">{{info.guanwang}}</div>
  </div>
</template>

<script>
  import { pcconfigApi } from '@/http/api.js'
  export default {
    name: 'my-footer',
    data() {
      return {
        revImgurl: '',
        info: {
          qrcode:'', // 二维码图片
          qrcodename:'', // 二维码名称
          company:'', // 公司名称
          address:'', // 公司地址
          mobile:'', // 电话
          guanwang:'', // 官网地址
          beianhao:'', // 备案号
          companyimg:'', //公司图
          logoimg:'', //Logo图
          topbackimg:'', //顶部背景图
        },
      }
    },
    created(){
      pcconfigApi().then(res=>{
        res.forEach(n=>{
          this.info[n.name] = n.value
        })
        let qrcode = document.getElementById('qrcode');
        let qrcodename = document.getElementById('qrcodename');
        let logoimg = document.getElementById('logoimg');
        let topbackimg = document.getElementById('topbackimg');
        if(qrcode){
          qrcode.src=this.info.qrcode
        }
        if(qrcodename){
          qrcodename.innerHTML = this.info.qrcodename
        }
        if(logoimg){
          logoimg.src=this.info.logoimg
        }
        if(topbackimg){
          topbackimg.style.backgroundImage = `url(${this.info.topbackimg})`;
        }
        console.log('info---', this.info)
      }).catch(()=>{
        
      })
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    background-color: #333333;
    font-size: .14rem;
    color: rgba(255, 255, 255, .6);
    line-height: 1.4;
    padding: .5rem 0;
  }
</style>